(function(){

    var Maps = {
    	section: null,
    	navItem: null,
    	mapPanel: null,
    	mapList: null,
    	mapItem: null,

    	init: function() {
    		Maps.section = $(".map.section");
    		Maps.controls = $(".map-controls");
    		Maps.navItem = $(".map-nav-item");
    		Maps.navItemDesc = $(".map-nav-description");
    		Maps.mapItem = $(".map");

    		Maps.getMap();

    		Maps.navItem.on("click",function(){
    			var selectedType = $(this).attr("data-map-type");
    			var selectedMap = $(".map-info[data-map-type='" + selectedType + "']")
    								.find(".map-list")
    								.find(".map-name")
    								.first()
    								.attr("data-map");
    			Maps.updatePanel(selectedType,selectedMap);
    		});

    		Maps.mapItem.on("click",function() {
    			Maps.updatePanel($(this)
    				.closest(".map-info")
    				.attr("data-map-type"),
    				$(this).attr("data-map"));
    		});

            /*
            * scroll to map by name based on url hash
            * need to setTimeout because of other scroll position js somewhere
            * $scrollspy and nav menu seems to interfere
            */
            function scrollByHash(){
                Maps.scrollTo(window.location.hash.slice(1));
            };

            setTimeout(scrollByHash, 500);

            // listen for hash changes
            // works on all browsers and ie8
            $(window).on('hashchange', function(){
                scrollByHash();
            });

            // listen for popstate changes
            // works on all browsers > ie9
            $(window).on('popstate', function(){
                scrollByHash();
            });
    	},

    	updatePanel: function(type,map) {
    		$(".map-nav-item").removeClass("active");
    		$(".map-nav-description").removeClass("active");
    		$(".map-info").removeClass("active");
    		$(".map-screen").removeClass("active");

    		$(".map-nav-item[data-map-type='" + type + "']").addClass("active");
    		$(".map-nav-description[data-map-type='" + type + "']").addClass("active");
    		$(".map-info[data-map-type='" + type + "']").addClass("active");
    		$(".map-name[data-map='" + map + "']").addClass("active");
    		$(".map-screen[data-map=" + map + "]").addClass("active");

    		Maps.getMap();
    	},

    	getMap: function() {
    		var activeMap = $(".map-screen.active").attr("data-map");
    		var activeType = $(".map-screen.active").attr("data-map-type");

    		Maps.mapItem.removeClass("active");

    		$(".map-info[data-map-type='" + activeType + "']")
    			.find(".map[data-map='" + activeMap + "']")
    			.addClass("active");
    	},

        /*
        * scroll to map section and click map by name
        * expects name to match a mapItem data-map value
        * ex: kings-row | hanamura | temple-of-anubis
        */
        scrollTo: function(name){
            if(!name) return;
            var $elem = Maps.mapItem.filter(['[data-map=', name, ']'].join(''));
            if($elem[0]){
                $('html, body').animate({
                    scrollTop: $('#objectives').offset().top
                }, 200, function(){
                    $elem.click();
                });
            }
        }

    };

    window.Maps = Maps;

}(window, window.overwatch));
